import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import Footer from '../components/Footer';
import '../styles/Legal.css';

const UPDATED = '11.06.2026';

const content = {
  tr: {
    badge: 'Gizlilik',
    title: 'Gizlilik Politikası',
    updated: `Son güncelleme: ${UPDATED}`,
    sections: [
      {
        title: '1. Giriş',
        body: `ViTex olarak kullanıcılarımızın gizliliğini ciddiye alıyoruz. Bu politika, vitex.app web sitesini ve
        masaüstü uygulamasını kullanmanız sırasında hangi bilgilerin toplandığını, nasıl kullanıldığını ve nasıl
        korunduğunu açıklamaktadır. KVKK kapsamındaki ayrıntılı bilgi için lütfen KVKK Aydınlatma Metni'ni inceleyiniz.`,
      },
      {
        title: '2. Topladığımız Veriler',
        body: null,
        items: [
          'Hesap bilgileri: Ad, soyad, e-posta adresi, şifreli parola.',
          'Ödeme ve fatura bilgileri: Ad, adres, telefon; kart bilgileri doğrudan ödeme sağlayıcısı (Iyzico) tarafından işlenir.',
          'Kullanım verileri: Transkripsiyon geçmişi (dosya adı, süre, dil), kalan dakika bakiyesi, sipariş geçmişi.',
          'Teknik veriler: Oturum tokenleri, tarayıcı dil tercihi (localStorage), sunucu log kayıtları.',
        ],
      },
      {
        title: '3. Yerel İşleme (Cihaz Üzerinde)',
        body: `Ses ve video dosyalarınız, masaüstü uygulamasında tamamen cihazınız üzerinde (yerel olarak)
        metne dönüştürülür ve hiçbir zaman ViTex sunucularına yüklenmez. Sunucularımıza yalnızca üst
        veriler (dosya adı, süre, dil ve kullanılan dakika) iletilir. URL ile indirme özelliği de
        indirme işlemini doğrudan sizin cihazınızda gerçekleştirir; indirilen içerik ViTex sunucularına
        aktarılmaz.`,
      },
      {
        title: '4. Verileri Nasıl Kullanıyoruz',
        body: null,
        items: [
          'Hesabınızı oluşturmak ve yönetmek.',
          'Abonelik ve ödeme işlemlerini gerçekleştirmek.',
          'Şifre sıfırlama ve e-posta doğrulama mesajları göndermek.',
          'Hizmetin güvenliğini ve sürdürülebilirliğini sağlamak.',
          'Yasal yükümlülükleri yerine getirmek.',
        ],
      },
      {
        title: '5. Veri Paylaşımı',
        body: `Kişisel verilerinizi üçüncü taraflara satmıyor, kiralamıyor veya ticaretini yapmıyoruz. Verileriniz yalnızca
        hizmetin sunulması için zorunlu olan aşağıdaki taraflarla paylaşılmaktadır:`,
        items: [
          'Iyzico Ödeme Hizmetleri A.Ş. — ödeme işlemi için.',
          'Resend Inc. — işlemsel e-posta gönderimi için.',
          'Yetkili kamu kurum ve kuruluşları — yasal zorunluluk halinde.',
        ],
      },
      {
        title: '6. Çerezler',
        body: `Web sitemiz yalnızca zorunlu ve işlevsel çerezler kullanmaktadır. Reklam veya üçüncü taraf takip
        çerezleri kullanılmamaktadır. Detaylı bilgi için Çerez Politikası'nı inceleyiniz.`,
      },
      {
        title: '7. Güvenlik',
        body: `Kişisel verilerinizi korumak için endüstri standardı güvenlik önlemleri uygulanmaktadır: şifreler
        bcrypt ile hashlenerek saklanmakta, API iletişimleri HTTPS üzerinden gerçekleştirilmekte ve JWT
        tabanlı kimlik doğrulama kullanılmaktadır. Bununla birlikte, internet üzerinden veri iletiminin
        %100 güvenli olduğu garanti edilemez.`,
      },
      {
        title: '8. Haklarınız',
        body: `KVKK kapsamındaki haklarınızı (erişim, düzeltme, silme, itiraz vb.) kullanmak için
        vitex.app@gmail.com adresine yazabilirsiniz. Ayrıntılar için KVKK Aydınlatma Metni'ni inceleyiniz.`,
      },
      {
        title: '9. Politika Değişiklikleri',
        body: `Bu politikayı zaman zaman güncelleyebiliriz. Önemli değişiklikler e-posta ile bildirilecek veya
        site üzerinde duyurulacaktır. Güncel tarih sayfanın üstünde gösterilmektedir.`,
      },
      {
        title: '10. İletişim',
        body: null,
        contact: { email: 'vitex.app@gmail.com' },
      },
    ],
  },
  en: {
    badge: 'Privacy',
    title: 'Privacy Policy',
    updated: `Last updated: ${UPDATED}`,
    sections: [
      {
        title: '1. Introduction',
        body: `At ViTex, we take your privacy seriously. This policy explains what information is collected when
        you use vitex.app and the ViTex desktop application, how it is used, and how it is protected.
        For KVKK-specific details (Turkish data protection law), please refer to our KVKK Notice.`,
      },
      {
        title: '2. Data We Collect',
        body: null,
        items: [
          'Account information: full name, email address, hashed password.',
          'Payment and billing details: name, address, phone; card data is processed directly by Iyzico.',
          'Usage data: transcription history (file name, duration, language), minute balance, order history.',
          'Technical data: session tokens, browser language preference (localStorage), server logs.',
        ],
      },
      {
        title: '3. Local (On-Device) Processing',
        body: `Your audio and video files are transcribed entirely on your own device in the desktop
        application and are never uploaded to ViTex servers. Only metadata (file name, duration,
        language, and minutes used) is sent to our servers. The URL download feature likewise performs
        downloads directly on your device; downloaded content is not transferred to ViTex servers.`,
      },
      {
        title: '4. How We Use Your Data',
        body: null,
        items: [
          'Create and manage your account.',
          'Process subscriptions and payments.',
          'Send password reset and email verification messages.',
          'Maintain service security and reliability.',
          'Fulfil legal obligations.',
        ],
      },
      {
        title: '5. Data Sharing',
        body: `We do not sell, rent, or trade your personal data. Data is shared only with the following
        parties as necessary to deliver the service:`,
        items: [
          'Iyzico Ödeme Hizmetleri A.Ş. — for payment processing.',
          'Resend Inc. — for transactional email delivery.',
          'Competent public authorities — when required by law.',
        ],
      },
      {
        title: '6. Cookies',
        body: `This site uses only strictly necessary and functional cookies. No advertising or third-party
        tracking cookies are used. See our Cookie Policy for details.`,
      },
      {
        title: '7. Security',
        body: `We apply industry-standard security measures: passwords are stored as bcrypt hashes, API
        communications use HTTPS, and authentication relies on short-lived JWTs with refresh tokens.
        No data transmission over the internet can be guaranteed 100% secure.`,
      },
      {
        title: '8. Your Rights',
        body: `To exercise your rights (access, correction, deletion, objection, etc.) under KVKK or other
        applicable laws, contact vitex.app@gmail.com. See the KVKK Notice for full details.`,
      },
      {
        title: '9. Policy Changes',
        body: `We may update this policy periodically. Material changes will be communicated by email or
        announced on the site. The effective date is shown at the top of this page.`,
      },
      {
        title: '10. Contact',
        body: null,
        contact: { email: 'vitex.app@gmail.com' },
      },
    ],
  },
};

export default function PrivacyPolicy() {
  const { lang, t } = useI18n();
  const c = content[lang] || content.tr;

  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header-inner">
          <Link to="/" className="legal-back-link">← {t('common.backToHome')}</Link>
          <span className="legal-header-title">{t('legal.privacy')}</span>
        </div>
      </header>

      <main className="legal-content">
        <span className="legal-badge">{c.badge}</span>
        <h1 className="legal-title">{c.title}</h1>
        <p className="legal-meta">{c.updated}</p>

        {c.sections.map((s, i) => (
          <div className="legal-section" key={i}>
            <h2>{s.title}</h2>
            {s.body && <p>{s.body}</p>}
            {s.items && (
              <ul>
                {s.items.map((item, j) => <li key={j}>{item}</li>)}
              </ul>
            )}
            {s.contact && (
              <div className="legal-contact-box">
                <p><strong>E-posta / Email:</strong>{' '}
                  <a href={`mailto:${s.contact.email}`}>{s.contact.email}</a>
                </p>
              </div>
            )}
          </div>
        ))}
      </main>

      <Footer />
    </div>
  );
}
